import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
type Step = {
  id: number;
  name: string;
  component: React.ReactNode;
};
interface LayoutProps {
  children: ReactNode;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  steps: Step[];
}
export function Layout({
  children,
  currentStep,
  setCurrentStep,
  steps
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-233">
      <Header data-id="element-234" />
      <div className="flex flex-1" data-id="element-235">
        <Sidebar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} data-id="element-236" />
        <main className="flex-1 p-6" data-id="element-237">{children}</main>
      </div>
    </div>;
}